const commonContactChannels = ["微信客服", "WhatsApp", "Telegram", "Line", "QQ", "电话", "邮箱"];

export const zhLegalContent = {
  eyebrow: "OrcaParcel Legal",
  tocAriaSuffix: "目录",
  contactCta: {
    title: "仍有疑问？",
    copy: "请联系虎鲸国际物流客服确认具体线路、费用、禁运品或服务保障规则。",
    actions: ["联系客服", "返回帮助中心"]
  },
  docs: {
    legalServiceAgreement: {
      title: "虎鲸国际物流 服务协议",
      description:
        "本协议用于说明用户使用虎鲸国际物流 OrcaParcel 平台服务时的基本规则，包括账户注册、仓库地址使用、包裹预报、仓储代收、拆箱合包、国际运输、费用支付及异常处理等内容。",
      notice: "本页面内容为服务规则说明，具体服务范围、费用、线路和时效以平台实际展示、仓库称重结果及具体线路规则为准。",
      lastUpdated: "最后更新时间：2025-06-27",
      sections: [
        {
          id: "scope",
          title: "1. 协议适用范围",
          paragraphs: [
            "用户访问、注册或使用 OrcaParcel 平台服务，即视为已了解并同意遵守本服务协议及平台展示的相关规则。",
            "服务范围包括但不限于仓库代收、包裹预报、拆箱合包、增值服务、运费估算、国际发运、物流追踪和客服协助。"
          ]
        },
        {
          id: "account",
          title: "2. 用户注册与账户管理",
          paragraphs: [
            "用户需要提供真实、准确、完整的注册信息，并应妥善保管账号、密码、验证码等账户安全信息。",
            "因用户自身原因导致账号被他人使用或信息错误，平台可协助处理，但不承担因信息错误造成的全部后果。"
          ]
        },
        {
          id: "warehouse-address",
          title: "3. 仓库地址使用规则",
          paragraphs: [
            "用户注册后可获得平台仓库地址及会员标识。用户在国内电商平台购物时，应按照平台要求填写收件人、电话、地址和会员标识。",
            "如用户未正确填写会员标识，可能导致包裹无法及时匹配或入库延迟。"
          ]
        },
        {
          id: "prealert",
          title: "4. 包裹预报规则",
          paragraphs: [
            "用户在购买商品后，应尽量及时提交包裹预报，包括国内快递单号、商品名称、数量、分类及备注。",
            "包裹预报有助于仓库更快识别和匹配包裹。未预报包裹可能需要人工核实，处理时间可能延长。"
          ]
        },
        {
          id: "storage",
          title: "5. 仓储代收规则",
          paragraphs: [
            "平台仓库可为用户代收符合规则的包裹，并在合理范围内进行仓储管理。",
            "平台当前为用户提供一定期限的免费仓储服务，具体免费仓储天数、计费规则及调整以平台页面展示为准。"
          ]
        },
        {
          id: "value-added",
          title: "6. 拆箱合包与增值服务",
          paragraphs: [
            "用户可根据需要选择拆箱合包、精简包装、加固包装、拍照验货、打包过程可视化、代购代付、上门取件等增值服务。",
            "不同服务可能产生不同费用，具体以平台展示为准。"
          ]
        },
        {
          id: "billing",
          title: "7. 运费估算与实际计费",
          paragraphs: ["运费估算结果仅供参考，实际费用以仓库实际称重、包裹尺寸、线路规则、附加费用及平台最终展示为准。"],
          bullets: ["实际重量", "体积重量", "目的国家或地区", "运输渠道", "货物类型", "附加服务", "偏远地区费用", "燃油或其他附加费用"]
        },
        {
          id: "transport-customs",
          title: "8. 国际运输与清关说明",
          paragraphs: [
            "国际运输过程中可能涉及承运商、海关、目的国派送服务商等第三方环节。",
            "参考时效不等于承诺到达时间。清关结果可能受目的国政策、商品属性、申报信息等因素影响。"
          ]
        },
        {
          id: "user-responsibility",
          title: "9. 用户责任",
          paragraphs: ["用户应按照平台和目的地规则使用服务，并及时处理与包裹相关的异常通知。"],
          bullets: ["提交信息真实准确", "不寄送禁运品", "如实申报商品信息", "按时支付相关费用", "及时处理异常通知", "遵守目的地国家或地区相关规定"]
        },
        {
          id: "platform-responsibility",
          title: "10. 平台服务责任",
          paragraphs: [
            "平台负责在服务范围内提供包裹处理、仓储管理、合箱打包、发运安排、物流追踪和客服协助。",
            "对于超出平台合理控制范围的情况，如海关查验、航班调整、天气原因、承运商延误等，平台将协助用户跟进处理。"
          ]
        },
        {
          id: "payment-refund",
          title: "11. 费用支付与退款说明",
          paragraphs: [
            "用户应在确认费用后支付运费及相关服务费用。",
            "已产生的服务费用、操作费用或第三方费用，是否可退以实际订单状态和平台规则为准。"
          ]
        },
        {
          id: "abnormal-parcel",
          title: "12. 异常包裹处理",
          paragraphs: ["异常包裹将结合用户反馈、仓库记录、渠道反馈和平台规则进行核实处理。"],
          bullets: ["包裹破损", "信息不符", "无法匹配用户", "疑似禁运品", "少件", "错发", "延误", "物流轨迹异常"],
          note: "常见处理方式包括用户提交反馈、客服核实信息、仓库或渠道协同排查，并根据实际情况给出处理方案。"
        },
        {
          id: "restricted-items",
          title: "13. 禁运品与限制品",
          paragraphs: [
            "用户不得寄送禁运品、违法违规物品或目的国禁止进口物品。",
            "具体规则请查看《禁运品须知》页面，并在发货前结合目的地和线路规则确认。"
          ]
        },
        {
          id: "changes",
          title: "14. 协议变更与通知",
          paragraphs: [
            "平台可根据业务、法规或线路规则调整服务协议。",
            "重要变更将通过官网、用户中心、站内信或其他合理方式通知。"
          ]
        },
        {
          id: "contact",
          title: "15. 联系方式",
          paragraphs: ["如对服务协议或具体服务规则有疑问，可通过以下渠道联系虎鲸国际物流客服确认。"],
          bullets: commonContactChannels
        }
      ]
    },
    legalPrivacyPolicy: {
      title: "虎鲸国际物流 隐私政策",
      description:
        "本隐私政策用于说明虎鲸国际物流 OrcaParcel 在提供国际集运、包裹转运、仓储代收、物流追踪和客服服务过程中，如何收集、使用、存储和保护用户信息。",
      notice: "我们仅在提供服务、保障账户安全、完成订单处理、客服沟通及合规要求所必要的范围内处理用户信息。",
      lastUpdated: "最后更新时间：2025-07-25",
      sections: [
        { id: "collection", title: "1. 我们收集的信息", paragraphs: ["平台可能收集用户主动提交的信息，以及用户在使用服务过程中产生的必要信息。"] },
        { id: "account-info", title: "2. 账户注册信息", paragraphs: ["账户注册信息用于账号创建、身份识别、登录验证和会员标识管理。"], bullets: ["手机号", "邮箱", "登录密码", "会员标识", "昵称", "语言偏好", "账号状态"] },
        {
          id: "parcel-order-info",
          title: "3. 包裹与订单信息",
          paragraphs: ["包裹与订单信息用于仓库识别、入库、合箱、发货、追踪和异常处理。"],
          bullets: ["国内快递单号", "商品名称", "商品分类", "商品数量", "包裹重量", "包裹尺寸", "包裹照片", "入库记录", "合箱记录", "发货订单", "物流轨迹", "异常处理记录"]
        },
        { id: "address-info", title: "4. 收件人与地址信息", paragraphs: ["这些信息用于国际发运、派送、清关协助和异常处理。"], bullets: ["收件人姓名", "联系电话", "收件地址", "国家或地区", "邮编", "清关所需信息，如适用"] },
        { id: "payment-info", title: "5. 支付与账单信息", paragraphs: ["如后续接入第三方支付，支付敏感信息由第三方支付机构处理，平台不保存完整银行卡等敏感支付信息。"], bullets: ["账单金额", "费用明细", "支付状态", "支付时间", "退款记录", "优惠信息，如有"] },
        { id: "support-info", title: "6. 客服沟通信息", paragraphs: ["客服沟通信息用于处理咨询、工单、售后反馈和异常包裹协助。"], bullets: ["工单内容", "聊天记录", "用户上传的图片或凭证", "客服处理记录", "售后反馈"] },
        { id: "device-log", title: "7. 设备与日志信息", paragraphs: ["设备与日志信息用于保障账户安全、系统稳定和问题排查。"], bullets: ["登录时间", "IP 地址", "浏览器类型", "设备信息", "操作日志", "异常访问记录"] },
        { id: "purpose", title: "8. 信息使用目的", paragraphs: ["平台将在必要范围内使用相关信息，以完成用户请求的服务和安全管理。"], bullets: ["账户注册和身份识别", "仓库入库和包裹匹配", "订单处理和国际发运", "费用结算", "物流追踪", "客服处理", "异常排查", "安全风控", "服务通知", "平台体验优化"] },
        {
          id: "sharing",
          title: "9. 信息共享与第三方服务",
          paragraphs: ["在完成服务所必要的情况下，平台可能与相关服务方共享必要信息。", "我们不会出售用户个人信息。"],
          bullets: ["仓库服务人员", "国际物流承运商", "目的地派送服务商", "支付服务商", "客服系统服务商", "技术服务提供商", "监管或执法机构，如依法要求"]
        },
        {
          id: "security",
          title: "10. 信息存储与安全保护",
          paragraphs: [
            "平台将采取合理的信息保护措施，包括访问权限控制、日志记录、数据备份、必要的加密或脱敏处理等。",
            "我们将采取合理且必要的技术和管理措施保护用户信息安全，但互联网环境仍存在一定安全风险，用户也应妥善保管账号和密码。"
          ]
        },
        { id: "manage-info", title: "11. 用户如何管理个人信息", paragraphs: ["用户可在个人中心查看、修改部分账户信息、地址信息和通知偏好。", "如需删除账号或处理隐私相关请求，可联系客服。"] },
        { id: "cookie", title: "12. Cookie 与类似技术", paragraphs: ["平台可能使用 Cookie 或类似技术用于登录状态保持、访问统计、偏好保存和安全识别。"] },
        { id: "minor", title: "13. 未成年人隐私保护", paragraphs: ["未成年人应在监护人同意和指导下使用平台服务。"] },
        { id: "updates", title: "14. 隐私政策更新", paragraphs: ["隐私政策可能根据业务变化或法规要求调整，更新后将通过官网或平台通知。"] },
        { id: "contact", title: "15. 联系我们", paragraphs: ["如对隐私政策或个人信息处理有疑问，可通过以下渠道联系虎鲸国际物流客服。"], bullets: commonContactChannels }
      ]
    },
    legalRestrictedItems: {
      title: "禁运品与限制寄送物品须知",
      description: "为保障包裹运输安全、清关合规和用户权益，请在提交包裹预报和申请发货前仔细了解禁运品、限制品和敏感货规则。",
      notice: "不同国家、地区及运输线路对可寄物品的要求可能不同，具体以实际线路规则、承运方要求及目的地海关规定为准。如不确定商品是否可寄，请先联系客服确认。",
      lastUpdated: "最后更新时间：2026-06-25",
      sections: [
        { id: "prohibited-definition", title: "1. 禁运品说明", paragraphs: ["禁运品是指根据法律法规、承运商规则、航空运输规则、海关规定或平台规则，不允许寄送的物品。"] },
        { id: "restricted-definition", title: "2. 限制寄送物品说明", paragraphs: ["限制品并非完全不能寄送，但可能需要满足特定条件。"], bullets: ["指定线路", "特殊包装", "补充资料", "申报文件", "特殊渠道", "额外费用", "目的地许可"] },
        { id: "sensitive-definition", title: "3. 敏感货说明", paragraphs: ["敏感货通常指运输、清关或派送环节存在额外要求的商品。是否可寄取决于具体线路和目的国家规则。"] },
        { id: "prohibited-categories", title: "4. 常见禁运品分类", paragraphs: ["以下为常见禁运品分类，实际禁运范围应以目的地、承运方和平台规则为准。"], bullets: ["易燃易爆品", "毒品及违禁药品", "枪支弹药及仿制品", "管制刀具", "现金、有价证券", "活体动植物", "腐败变质食品", "侵权假冒商品", "危险化学品", "放射性物品", "压缩气体", "非法出版物", "目的国禁止进口物品", "其他法律法规禁止运输的物品"] },
        { id: "sensitive-categories", title: "5. 常见敏感货分类", paragraphs: ["敏感货不代表均可寄送，需联系客服确认可用线路和申报要求。"], bullets: ["带电产品", "内置电池商品", "液体", "粉末", "膏体", "化妆品", "食品", "药品或保健品", "品牌商品", "磁性物品", "电子产品", "成人用品", "厨房刀具或工具类商品"] },
        { id: "regional-rules", title: "6. 各国家和地区规则差异", paragraphs: ["不同国家或地区对食品、药品、电池、品牌商品、木制品、液体、粉末等商品要求不同。", "用户应在发货前确认目的地规则。"] },
        { id: "declaration-responsibility", title: "7. 用户申报责任", paragraphs: ["用户需要如实申报商品信息。如用户隐瞒、虚假申报或误报，可能导致包裹延误、退回、扣留、罚款或销毁等风险。"], bullets: ["商品名称", "数量", "材质", "用途", "品牌", "价值", "是否带电", "是否液体 / 粉末 / 膏体"] },
        { id: "inspection", title: "8. 包裹查验规则", paragraphs: ["平台仓库可根据服务需要、线路要求或异常判断，对包裹进行必要查验。", "如发现疑似禁运品或信息不符，平台可暂停发货并联系用户确认。"] },
        { id: "handling", title: "9. 发现禁运品后的处理方式", paragraphs: ["发现禁运品或疑似禁限寄物品后，平台将根据实际情况和规则处理。"], bullets: ["通知用户补充说明", "取消发货", "退回国内地址", "拆分可寄与不可寄商品", "按规定移交或处理", "根据承运方或监管要求处理"] },
        { id: "risks", title: "10. 退回、销毁、扣留等风险", paragraphs: ["因禁运品、限制品、虚假申报或目的地政策导致的退回、销毁、扣留、罚款、延误等风险，可能由用户承担。"] },
        { id: "before-shipping", title: "11. 发货前确认建议", paragraphs: ["建议用户发货前主动核对货物属性和目的地规则。"], bullets: ["查看禁运品须知", "联系客服确认敏感货", "如实填写包裹预报", "保留商品购买凭证", "不要混装不确定商品"] },
        { id: "contact", title: "12. 联系客服确认", paragraphs: ["如不确定商品是否可寄，请联系虎鲸国际物流客服确认。"] }
      ]
    },
    legalServiceGuarantee: {
      title: "虎鲸国际物流 服务保障条款",
      description: "本页面用于说明平台在仓储代收、包裹处理、拆箱合包、国际运输、物流追踪和异常处理过程中的服务保障范围、处理流程及注意事项。",
      notice: "服务保障不等于绝对承诺。包裹异常、破损、丢失、延误等情况，将根据实际服务记录、线路规则、承运方反馈及平台服务保障条款协助处理。",
      lastUpdated: "最后更新时间：2026-06-27",
      sections: [
        { id: "scope", title: "1. 服务保障适用范围", paragraphs: ["适用于用户通过 OrcaParcel 平台提交并完成处理的包裹。"], bullets: ["包裹预报", "仓库入库", "仓储保管", "拆箱合包", "增值服务", "国际发运", "物流追踪", "异常协助"] },
        { id: "inbound", title: "2. 包裹入库保障", paragraphs: ["平台仓库会根据包裹信息、会员标识和预报信息进行入库匹配。如包裹信息完整，通常可以更快识别。", "如会员标识缺失、快递单号错误、包裹信息不完整，可能导致入库延迟。"] },
        { id: "storage", title: "3. 仓储保管说明", paragraphs: ["包裹入库后，平台将在合理范围内进行仓储管理。", "平台当前为用户提供一定期限的免费仓储服务，超过免费仓储期限后的处理方式或费用规则，以平台实际公布内容为准。"] },
        { id: "packing", title: "4. 拆箱合包服务说明", paragraphs: ["用户选择拆箱合包、加固包装、拍照验货、精简包装等服务后，仓库将根据用户选择和包裹实际情况处理。", "由于商品材质、包装状态和运输环境不同，打包服务只能降低运输风险，不能完全消除运输风险。"] },
        { id: "fee-transparency", title: "5. 费用透明说明", paragraphs: ["运费估算仅供参考，实际费用以仓库称重结果、包裹尺寸、所选线路及平台最终展示为准。"], bullets: ["国际运费", "增值服务费", "附加费用", "偏远地区费用，如有", "特殊线路费用，如有", "仓储费用，如有"] },
        { id: "transport-exception", title: "6. 运输异常处理", paragraphs: ["运输异常发生后，平台将协助用户联系仓库、渠道或承运商进行核实。"], bullets: ["物流轨迹长时间未更新", "清关查验", "派送失败", "地址异常", "承运商延误", "包裹退回", "包裹破损", "包裹疑似丢失"] },
        { id: "delay", title: "7. 延误处理说明", paragraphs: ["国际运输可能受航班、船期、天气、海关查验、目的地派送、节假日、承运商调整等因素影响。", "平台将根据实际情况协助用户跟进处理，具体处理方式以线路规则和服务保障条款为准。"] },
        { id: "damage-loss", title: "8. 破损、丢失、少件处理", paragraphs: ["如用户反馈包裹破损、丢失或少件，平台将根据用户提交的材料、仓库操作记录、包裹照片、物流记录及承运方反馈进行核实，并根据服务保障规则协助处理。"] },
        { id: "materials", title: "9. 用户需提供的证明材料", paragraphs: ["不同异常类型可能需要不同证明材料，用户应按客服指引尽量完整提交。"], bullets: ["商品购买凭证", "商品图片", "包裹外包装照片", "开箱视频", "物流单号", "订单截图", "问题说明", "收件人反馈"] },
        { id: "not-covered", title: "10. 不适用保障的情形", paragraphs: ["以下情形可能不适用服务保障，或需结合实际情况和线路规则判断。"], bullets: ["用户寄送禁运品或限制品", "用户虚假申报", "用户填写地址错误", "用户未正确填写会员标识", "商品本身易碎、易漏、易变质", "外包装不适合长途运输", "海关扣留或目的国政策限制", "用户未按要求提供证明材料", "超出平台可控制范围的第三方原因"] },
        { id: "disclaimer", title: "11. 免责说明", paragraphs: ["平台不对以下情况作绝对承诺，相关处理将结合实际记录、线路规则和正式条款判断。"], bullets: ["运输时效绝对到达", "海关查验结果", "目的地派送速度", "承运商临时调整", "不可抗力因素", "用户自身填写错误导致的问题"] },
        { id: "process", title: "12. 异常处理流程", paragraphs: ["异常处理将通过工单和客服沟通逐步推进。"], bullets: ["1. 用户提交问题反馈", "2. 客服初步核实", "3. 仓库 / 渠道 / 承运商协同排查", "4. 用户补充证明材料，如需要", "5. 平台根据规则给出处理方案", "6. 工单关闭或继续跟进"] },
        { id: "handling-time", title: "13. 处理时效说明", paragraphs: ["不同异常类型涉及的核实环节不同，处理时间可能存在差异。", "平台将在收到完整信息后尽快协助核实，并通过站内信、邮件或客服渠道反馈处理进展。"] },
        { id: "contact", title: "14. 联系客服", paragraphs: ["如对服务保障范围或异常处理有疑问，可联系虎鲸国际物流客服确认。"] }
      ]
    }
  }
} as const;
